import {
  GetFilteredInvoicesResponseObj,
  GetIfInvoicesResponseObj,
  GetIfInvoicesSummaryResponseObj,
} from "@/types/interfaces/crm";
import axiosInstance from "../axiosInstance";

export const getFilteredInvoices = async (productCodes: string[]): Promise<GetFilteredInvoicesResponseObj> => {
  const res = await axiosInstance.get("/crm/admin/finance-qa/invoices", { params: { productCodes } });
  const { data, meta } = res.data;

  return {
    invoices: data || [],
    metaInfo: meta,
  };
};

export const getInvoices = async (): Promise<GetIfInvoicesResponseObj> => {
  const res = await axiosInstance.get("/crm/admin/if-invoices");
  return {
    invoices: res.data?.data || [],
    metaInfo: res.data?.meta || {},
  };
};

export const getInvoicesSummary = async (): Promise<GetIfInvoicesSummaryResponseObj> => {
  const res = await axiosInstance.get("/crm/admin/finance-qa/summary");
  return {
    data: res.data?.data || [],
    metaInfo: res.data?.meta || {},
  };
};
